import React from 'react';
import { classnames } from 'Utils/classnames/classnames.utils';
import { get } from 'lodash';
import type { FieldProps } from 'formik';
import 'formik';
import { getValidationStatus } from 'Components/frameworks/formik/inputsUtils';
import { RadioButton } from 'Components/frameworks/form-inputs/radio-button/RadioButton';
type Props = FieldProps & {
  className?: string;
  isDisabled?: boolean;
  isLoading?: boolean;
  isReadOnly?: boolean;
  isRequired: boolean;
  label?: string | Node;
  size?: string;
  itemsCentered?: boolean;
};
export const Radio = ({
  className,
  field,
  form,
  isDisabled,
  isLoading,
  isReadOnly,
  isRequired,
  label,
  onChange,
  size,
  itemsCentered = true,
}: Props) => {
  const formValue = get(form.values, field.name, '');
  const { isErrored } = getValidationStatus({ ...field, formValue }, form);
  // values can be integer at form initialize but finally it's always a string, so we ensure it
  const isChecked = formValue.toString() === field.value.toString();
  return (
    <label
      htmlFor={`radio-${field.name}-${field.value}`}
      className={classnames(
        'flex min-h-48 w-full gap-10 text-14',
        {
          'cursor-pointer': !isDisabled && !isLoading,
          'cursor-wait': isLoading,
          'cursor-not-allowed': isDisabled,
          'formik-errored': isErrored && isRequired,
          'items-center': itemsCentered,
        },
        className,
      )}
    >
      <RadioButton className={size} isChecked={isChecked} isDisabled={isDisabled || isReadOnly} />
      <input
        {...field}
        checked={isChecked}
        className="sr-only"
        disabled={isDisabled}
        id={`radio-${field.name}-${field.value}`}
        type="radio"
        onChange={(event) => {
          field.onChange(event);

          if (onChange) {
            onChange(event);
          }
        }}
      />
      {label && <span className="text-14 leading-normal text-black">{label}</span>}
    </label>
  );
};
